import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './api/setupAxios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initUpdateNotifier } from './api/updateNotifier';

// Unregister any legacy service workers (e.g. old CRA Workbox at /service-worker.js)
// that might still be caching stale assets like bundle.js.
// OJO: /push-sw.js (ámbito /avisos/) es el de las notificaciones y NO se toca: al
// desregistrarlo el móvil pierde su suscripción. Antes se borraba en cada arranque
// ("push-sw.js" no acaba en "/sw.js") y a quien la tenía ahí dejaban de llegarle los
// avisos (y en Xiaomi, de tanto volver a suscribirse, Google acababa rechazándolo).
const SW_DE_LA_APP = ['/sw.js', '/push-sw.js'];
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(function(registrations) {
    registrations.forEach(function(reg) {
      const swUrl = reg.active?.scriptURL || reg.installing?.scriptURL || reg.waiting?.scriptURL || '';
      let ruta = '';
      try { ruta = new URL(swUrl).pathname; } catch (_) { ruta = swUrl; }
      if (swUrl && !SW_DE_LA_APP.includes(ruta)) {
        console.info('[App] Desregistrando SW antiguo:', swUrl);
        reg.unregister();
      }
    });
  });
}

// Una vez por móvil: borra la caché HTTP del navegador para esta web (páginas y JS
// guardados). Hasta el 19/08 la página se podía guardar y, al ir "atrás" en el
// historial, Chrome abría esa copia vieja sin preguntar al servidor (p. ej. 47
// preguntas en el reporte). No toca la sesión, localStorage, sessionStorage ni los
// service workers (avisos). Por detrás y a los pocos segundos, para no frenar el arranque.
const LIMPIEZA_CACHE = 'cacheNavegadorLimpiada_2026_10';
try {
  if (!localStorage.getItem(LIMPIEZA_CACHE)) {
    setTimeout(() => {
      fetch('/api/app/limpiar-cache', { cache: 'no-store' })
        .then((r) => { if (r.ok) localStorage.setItem(LIMPIEZA_CACHE, new Date().toISOString()); })
        .catch(() => {}); // sin conexión: se reintenta en el próximo arranque
    }, 8000);
  }
} catch (_) {}

// Registra /sw.js para TODOS los roles (antes solo se registraba al activar
// notificaciones desde el panel de supervisora) y avisa con <UpdateBanner />
// cuando detecta que hay una versión nueva de la app corriendo.
initUpdateNotifier();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
